const SlotMachine = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 7.5A1.5 1.5 0 0 0 4.5 9v6A1.5 1.5 0 0 0 6 16.5h2v-9zm3 0v9h3.5v-9zm4.5 0v9h2A1.5 1.5 0 0 0 17 15V9a1.5 1.5 0 0 0-1.5-1.5zM3.5 9A2.5 2.5 0 0 1 6 6.5h9.5A2.5 2.5 0 0 1 18 9v3.5h2a1.5 1.5 0 0 0 1.5-1.5V7a.5.5 0 0 1 1 0v4a2.5 2.5 0 0 1-2.5 2.5h-2V15a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 15z"
      clipRule="evenodd"
    />
  </>
)
export default SlotMachine
